import FormValidation from '@/js/components/forms/formValidation';
import EstateFilterForm from '@/js/components/forms/estateFilterForm';
import ScreenSizes from '@/js/components/screensizes/screensizes';
import GoogleAdvertisement from '@/js/components/googleAdvertisments/advertisement';
import AdvertisingSizes from '@/js/components/googleAdvertisments/sizes';

class Home {
  constructor() {
    this.dom = {
      filterForm: document.getElementById('filter-form'),
      formSubscriber: document.getElementById('form-subscriber'),
      googleAdvertisementDesktop: document.getElementById('banner-homepage-desktop'),
      googleAdvertisementMobile: document.getElementById('banner-homepage-mobile'),
    };

    this.components = {
      filterForm: null,
      subscriberFormValidation: null,
      screenSizes: null,
      googleAdvertisementDesktop: null,
    };

    this.data = {
      sizesLandscape: new AdvertisingSizes().advertisingSizes.sizesLandscape,
      sizeLandscapeMappingRules: new AdvertisingSizes().advertisingSizes.sizeLandscapeMappingRules,
    };
  }

  mount() {
    if (this.dom.googleAdvertisementDesktop) {
      window.didomiOnReady = window.didomiOnReady || [];
      window.didomiOnReady.push(() => {
        // Call other functions on the SDK
        this.initGoogleAdvertisements();
      });
    }

    if (this.dom.filterForm) {
      this.components.filterForm = new EstateFilterForm(this.dom.filterForm);
      this.components.filterForm.props.submitOnChange = false;
    }

    if (this.dom.formSubscriber) {
      this.components.subscriberFormValidation = new FormValidation(this.dom.formSubscriber);
    }

    this.components.screenSizes = new ScreenSizes();
    if (!this.components.screenSizes.isDesktop()) {
      this.dom.googleAdvertisementMobile.appendChild(this.dom.googleAdvertisementDesktop);
    }
  }

  /**
   * Create the Google Advertisement and listen when the banner is created
   */
  initGoogleAdvertisements() {
    this.components.googleAdvertisementDesktop = new GoogleAdvertisement({
      container: this.dom.googleAdvertisementDesktop,
      adUnitPath: this.dom.googleAdvertisementDesktop.dataset.adUnitPath,
      setTechnicalTarget: this.dom.googleAdvertisementDesktop.dataset.setTechnicalTarget !== undefined,
      sizes: this.data.sizesLandscape,
      sizeMappingRules: this.data.sizeLandscapeMappingRules,
      scrollVisibility: this.dom.googleAdvertisementDesktop.dataset.scrollVisibility ? this.dom.googleAdvertisementDesktop.dataset.scrollVisibility : 0,
    });

    GoogleAdvertisement.initializeGpt();

    window.googletag.cmd.push(() => {
      window.googletag.display(this.dom.googleAdvertisementDesktop.id);
    });

    this.calculateAdvertisementHeights();
    window.addEventListener('adSlotRendered', () => {
      this.calculateAdvertisementHeights();
    });
  }

  /**
   * Calculate the height of the desktop / mobile banners and adjust the height of the hero
   */
  calculateAdvertisementHeights() {
    if (this.dom.googleAdvertisementDesktop) {
      if (this.dom.googleAdvertisementDesktop.parentElement.getBoundingClientRect().height > 0) {
        document.documentElement.style.setProperty('--home-desktop-leaderboard-height', `${Math.round(this.dom.googleAdvertisementDesktop.parentElement.getBoundingClientRect().height * 0.5)}px`);
      } else {
        document.documentElement.style.setProperty('--home-desktop-leaderboard-height', '0px');
      }
    }
    if (this.dom.googleAdvertisementMobile) {
      if (this.dom.googleAdvertisementMobile.parentElement.getBoundingClientRect().height > 0) {
        document.documentElement.style.setProperty('--home-mobile-leaderboard-height', `${Math.round(this.dom.googleAdvertisementMobile.parentElement.getBoundingClientRect().height)}px`);
      } else {
        document.documentElement.style.setProperty('--home-mobile-leaderboard-height', '0px');
      }
    }
  }
}

if (document.getElementById('page-home')) {
  new Home().mount();
}
